type SlotState = 'good' | 'half' | 'defect' | 'idle' | 'offline' | 'active';

interface SlotGridStatusProps {
  slots: SlotState[];
  columns?: 4 | 8;
  compact?: boolean;
}

const slotClass: Record<SlotState, string> = {
  good: 'bg-console-good shadow-[0_0_10px_rgba(132,204,22,0.28)]',
  half: 'bg-console-half shadow-[0_0_10px_rgba(245,158,11,0.28)]',
  defect: 'bg-console-defect shadow-[0_0_12px_rgba(239,68,68,0.38)]',
  idle: 'bg-console-panelHigh',
  offline: 'bg-console-line',
  active: 'bg-console-blueSoft shadow-[0_0_10px_rgba(173,198,255,0.35)]',
};

export function SlotGridStatus({ slots, columns = 4, compact = false }: SlotGridStatusProps) {
  const normalizedSlots = slots.length >= 16 ? slots.slice(0, 16) : [...slots, ...Array(16 - slots.length).fill('idle')];

  return (
    <div
      className={`grid rounded border border-console-border bg-console-base/70 p-2 ${columns === 8 ? 'grid-cols-8' : 'grid-cols-4'} ${
        compact ? 'gap-2' : 'gap-3'
      }`}
    >
      {normalizedSlots.map((slot, index) => (
        <span
          key={`${slot}-${index}`}
          aria-label={`Slot ${index + 1}: ${slot}`}
          className={`aspect-square rounded-sm ${slotClass[slot as SlotState]}`}
        />
      ))}
    </div>
  );
}

export type { SlotState };
